<template>
    <div v-if="dialogVisible" class="modal-mask" id="modalPayAnimation">
        <div class="custom-modal-wrapper">
            <div class="custom-modal-container">
                <div class="custom-modal-custom-header">
                    <a href="javascript:void(0)" @click="close()">
                        <svg style="float: right;" width="18" height="18" viewBox="0 0 18 18" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 1L1 17" stroke="black" stroke-width="2"/>
                            <path d="M1 1L17 17" stroke="black" stroke-width="2"/>
                        </svg>
                    </a>
                </div>
                <div class="custom-modal-body">
                    <div class="text-center">
                        <div style="display: inline-block; width: 100%; margin-top: 35px;">
                          <svg height="60px" width="60px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                               viewBox="0 0 512 512" xml:space="preserve">
                            <path style="fill:#FF9900;" d="M507.494,426.066L282.864,53.536c-5.677-9.415-15.87-15.172-26.865-15.172
                              c-10.994,0-21.188,5.756-26.865,15.172L4.506,426.066c-5.842,9.689-6.015,21.774-0.451,31.625
                              c5.564,9.852,16.001,15.944,27.315,15.944h449.259c11.314,0,21.751-6.093,27.315-15.944
                              C513.509,447.839,513.336,435.755,507.494,426.066z"/>
                            <path style="fill:#FFDC35;" d="M255.999,38.365c-10.994,0-21.188,5.756-26.865,15.172L4.506,426.066
                              c-5.842,9.689-6.015,21.774-0.451,31.625c5.564,9.852,16.001,15.944,27.315,15.944h224.629L255.999,38.365L255.999,38.365z"/>
                            <path style="fill:#F20013;" d="M445.326,432.791H67.108c-3.591,0-6.911-1.909-8.718-5.012c-1.807-3.104-1.827-6.934-0.055-10.056
                              L247.23,85.028c1.792-3.155,5.139-5.106,8.767-5.107c0.001,0,0.003,0,0.004,0c3.626,0,6.974,1.946,8.767,5.099l189.324,332.694
                              c1.777,3.123,1.759,6.955-0.047,10.061S448.918,432.791,445.326,432.791z M84.436,412.616h343.543L256.013,110.423L84.436,412.616z"
                            />
                            <path style="fill:#FF4B00;" d="M256.332,412.616H84.436l171.576-302.192l-0.01-30.501h-0.005c-3.628,0.001-6.976,1.951-8.767,5.107
                              L58.336,417.722c-1.773,3.123-1.752,6.953,0.055,10.056c1.807,3.104,5.127,5.012,8.718,5.012h189.224v-20.175H256.332z"/>
                            <path style="fill:#533F29;" d="M279.364,376.883c0,12.344-10.537,23.182-22.88,23.182c-13.246,0-23.182-10.838-23.182-23.182
                              c0-12.644,9.935-23.182,23.182-23.182C268.826,353.701,279.364,364.238,279.364,376.883z M273.644,319.681
                              c0,9.333-10.236,13.246-17.462,13.246c-9.634,0-17.762-3.914-17.762-13.246c0-35.826-4.214-87.308-4.214-123.134
                              c0-11.741,9.634-18.365,21.977-18.365c11.741,0,21.677,6.623,21.677,18.365C277.858,232.373,273.644,283.855,273.644,319.681z"/>
                            </svg>
                        </div>
                        <div class="message">
                          Перевищено ліміт договорів СК «{{ companyName }}» на даного клієнта
                        </div>
                    </div>
                    <div class="text-center">
                        <div class="modal-text-item">
                          За правилами СК «{{ companyName }}» на одного страхувальника можна оформити до {{ allowedContracts }} договорів на рік.
                        </div>
                        <div class="modal-text-item">
                          Якщо клієнту потрібно оформити більше, ми можемо запросити індивідуальне погодження.
                        </div>
                        <div class="modal-text-item">
                          Натисніть «Погодити клієнта» для запиту в СК або оберіть іншу СК.
                        </div>
                        <div v-if="resultMessage" class="modal-text-item result-message" :class="{ 'is-error': resultIsError }">
                          <b>{{ resultMessage }}</b>
                        </div>
                      <br>
                      <button
                        v-if="!requested"
                        class="btn btn-blue close-btn-down"
                        :disabled="loading"
                        @click="requestApproval()"
                      >
                        {{ loading ? 'Надсилаємо...' : 'Погодити клієнта' }}
                      </button>
                      <button @click="chooseAnotherCompany()" class="btn btn-outline-blue close-btn-down">
                        Обрати іншу СК
                      </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { requestClientLimitApproval } from '@/entities/insurance/api';

export const CONTRACT_LIMIT_ERROR = 'CompanyClientContractLimit exceeded';

export default {
  name: 'CompanyClientContractLimit',
  props: {
    companyName: {
      type: String,
      default: 'Арсенал',
    },
    allowed: {
      type: [Number, String],
      default: 3,
    },
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      requested: false,
      resultMessage: null,
      resultIsError: false,
      payload: null,
    };
  },
  computed: {
    /**
     * Фактичний ліміт з відповіді бекенду (налаштування СК або індивідуальне погодження);
     * пропс — лише запасний варіант, якщо сервер не повернув число.
     */
    allowedContracts() {
      const fromServer = Number(this.payload?.allowed);

      return Number.isInteger(fromServer) && fromServer > 0 ? fromServer : this.allowed;
    },
  },
  methods: {
    close() {
      this.dialogVisible = false;
      this.loading = false;
      this.requested = false;
      this.resultMessage = null;
      this.resultIsError = false;
      this.payload = null;
    },
    /**
     * @param {{offerId: string, orderId?: string, customer: object, allowed?: number, active?: number}} payload —
     * дані замовлення, за якими сервер створить запит на погодження (offerId + customer.identificationCode),
     * та фактичний ліміт (allowed) і кількість діючих договорів (active) з відповіді сервера.
     */
    open(payload) {
      this.payload = payload || null;
      this.dialogVisible = true;
    },
    async requestApproval() {
      if (!this.payload?.offerId || !this.payload?.customer?.identificationCode) {
        this.resultMessage = 'Не вдалося визначити ІПН клієнта або пропозицію СК. Спробуйте ще раз.';
        this.resultIsError = true;
        return;
      }

      this.loading = true;
      this.resultMessage = null;
      this.resultIsError = false;

      try {
        const response = await requestClientLimitApproval({
          offerId: this.payload.offerId,
          orderId: this.payload.orderId || null,
          customer: {
            identificationCode: this.payload.customer.identificationCode,
            surname: this.payload.customer.surname,
            name: this.payload.customer.name,
            patronymic: this.payload.customer.patronymic,
          },
        });

        this.requested = true;
        this.resultMessage = response?.data?.alreadyRequested
          ? 'Запит на погодження вже надіслано та очікує розгляду. Ми повідомимо вас про результат.'
          : 'Запит надіслано. Ми повідомимо вас у кабінеті та в Telegram, щойно СК погодить клієнта.';
      } catch (error) {
        this.resultMessage = error?.response?.data?.message || 'Не вдалося надіслати запит. Спробуйте пізніше.';
        this.resultIsError = true;
      } finally {
        this.loading = false;
      }
    },
    chooseAnotherCompany() {
      this.close();
      this.$emit('choose-another-company');
    },
  },
};
</script>


<style lang="scss" scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.custom-modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.custom-modal-container {
    .policy-link {
        width: 436px;
        height: 64px;
        background: #F6F7FB;
        border-radius: 5px;
        display: flex;
        @media (max-width: 992px) {
            width: 300px;
        }

        .link {
            margin: auto 0 auto 12px;
            white-space: nowrap;
            overflow: hidden;
            max-width: 67%;
            padding: 5px;
            text-overflow: ellipsis;

            @media (max-width: 992px) {
                margin: auto 0 auto 2px;
            }
        }
    }
    .message {
      max-width: 420px;
      margin: 12px auto 10px auto;
      font-family: Circe,serif;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 29px;
        text-align: center;
        color: #24282C;

        @media (max-width: 992px) {
            font-size: 17px;
            line-height: 20px;
        }
    }

    .mtsbu-icon {
        margin: auto 0 auto 20px;

        @media (max-width: 992px) {
            margin: auto 0 auto 5px;
        }
    }

    .result-message { font-weight: bold; color: #1a9c4a; }
    .result-message.is-error { color: #F20013; }

    .modal-text-item {
      margin-top: 10px;
      width: 100%;
      //height: 22px;
      font-family: 'Circe', sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 22px;
      text-align: center;
      color: #24282C;

      svg {
        margin-right: 10px;
        width: 25px;
        height: 25px;
      }
    }

  .close-btn-down {
    min-width: 130px;
    width: auto;
    padding: 10px 16px;
    margin: 4px;
    white-space: nowrap;
  }

    @media (max-width: 992px) {
        width:358px;
    }
    width: 516px;
    height: auto;
    min-height: 360px;
    max-height: 90vh;
    overflow-y: auto;
    background: #FFFFFF;
    border-radius: 5px;
    margin: 0 auto;
    padding: 20px 30px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.custom-modal-custom-header h3 {
    margin-top: 0;
    color: #42b983;
}

.custom-modal-body {
    margin: 20px 0;
}

.modal-default-button {
    float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .custom-modal-container,
.modal-leave-active .custom-modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

</style>
